<template>
  <c-modal
    class="c-blogDelete"
    title="投稿の削除"
    :width="288"
    :active="isVisible"
    @close="$emit('close')"
  >
    <slot name="body">
      編集中のブログを削除します。<br>
      よろしいですか？
    </slot>
    <div slot="footer">
      <div class="c-blogDelete_action">
        <c-button
          class="c-blogDelete_cancel"
          @click="$emit('close')"
        >{{ closeText }}</c-button>
        <c-button
          color="secondary"
          :is-outlined="true"
          @click="$emit('deleteBlog')"
        >削除する</c-button>
      </div>
    </div>
  </c-modal>
</template>
<script>
export default {
  name: 'BlogDeleteModal',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    closeText: {
      type: String,
      default: '編集を続ける'
    }
  }
}
</script>

<style lang="scss" scoped>
.c-blogDelete {
  &_action {
    display: flex;
    justify-content: center;
  }
  &_cancel {
    margin-right: 12px;
    color: $color-gray-600;
  }

  button {
    width: 126px;
  }
}
</style>
